import { render, staticRenderFns } from "./PrkStudentWorkload.vue?vue&type=template&id=ca73de6e&scoped=true&"
import script from "./PrkStudentWorkload.vue?vue&type=script&lang=js&"
export * from "./PrkStudentWorkload.vue?vue&type=script&lang=js&"
import style0 from "./PrkStudentWorkload.vue?vue&type=style&index=0&id=ca73de6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca73de6e",
  null
  
)

export default component.exports